// Module
var code = "<md-icon class=\"material-icons md-{{ ::size }} work-order-priority-icon work-order-priority-icon--high\" md-svg-icon=\"/img/priority/high.svg\"></md-icon> ";
// Exports
module.exports = code;